import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyCOQpcKbzkIDUeYebNy9syneowhq4lMW6Q",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "rascaygana-pamplonews.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "rascaygana-pamplonews",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "rascaygana-pamplonews.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "427766118420",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:427766118420:web:8cbe3aa73e2c6ac00a8f01"
};

// Initialize Firebase
let app;
let auth;

// Check if Firebase is already initialized globally (from index.html)
if (window.firebaseApp && window.firebaseAuth) {
  console.log('✅ Using globally initialized Firebase');
  app = window.firebaseApp;
  auth = window.firebaseAuth;
} else {
  console.log('🔧 Initializing Firebase from config');
  app = initializeApp(firebaseConfig);
  auth = getAuth(app);
}

// Initialize Firebase Authentication and get a reference to the service
export { auth };
export default app; 